import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import useRetryFetch from "../hooks/useRetryFetch";
import "./Register.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  solid /* regular */,
} from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { config } from "../Environment";

function UserRoleList({ roles }) {
  const { t } = useTranslation();
  const listItems = [];
  for(let i = 0; i < roles.length; i += 1) {
    listItems.push(<li key={i}>{roles[i]}
    </li>);
  }
  return <ul>{listItems}</ul>
}

function MyUserProfile() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const retryFetch = useRetryFetch();
  const { id } = useParams();

  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const displayNameRef = useRef();
  
  const [displayName, setDisplayName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [roles, setRoles] = useState([]);
  const [grantRoles, setGrantRoles] = useState([]);
  const [revokeRoles, setRevokeRoles] = useState([]);
  const [roleInput, setRoleInput] = useState("");
  const [createdOn, setCreatedOn] = useState(0);
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    console.log(`UserProfile useEffect called`);
    // load user profile
    (async () => {
      const userProfileResponse = await retryFetch(config.API_BASE + `/api/user/profile`, { credentials: "include" });
      if (userProfileResponse.ok) {
        const userProfileData = await userProfileResponse.json();
        if (userProfileData.item) {
          const userProfile = userProfileData.item;
          setDisplayName(userProfile.displayName ?? '');
          setFirstName(userProfile.firstName ?? '');
          setLastName(userProfile.lastName ?? '');
          setEmail(userProfile.email ?? '');
          setRoles(userProfile.roles ?? []);
          setCreatedOn(userProfile.createdOn ?? 'Unknown');
        }  
      }
    })();

    return () => {
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const changeRequest = {};
    if (displayName) {
      changeRequest.displayName = displayName;
    }
    if (firstName) {
      changeRequest.firstName = firstName;
    }
    if (lastName) {
      changeRequest.lastName = lastName;
    }
    if (email) {
      changeRequest.email = email;
    }
    if (Array.isArray(grantRoles) && grantRoles.length > 0) {
      changeRequest.grantRoles = grantRoles;
    }
    if (Array.isArray(revokeRoles) && revokeRoles.length > 0) {
      changeRequest.revokeRoles = revokeRoles;
    }

    let response = await retryFetch(config.API_BASE + `/api/user/profile/edit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(changeRequest),
      credentials: "include",
    });
    if (!response.ok) {
      setErrMsg(t("msg_error_save_failed"));
      //emailRef.current.focus();
    } else {
      setSuccess(true);
      window.setTimeout(() => {
        navigate("/portal");
      }, 2000);
    }
  };

  const changeFirstName = (e) => {
    setFirstName(e.target.value);
  };
  const changeLastName = (e) => {
    setLastName(e.target.value);
  };
  const changeDisplayName = (e) => {
    setDisplayName(e.target.value);
  };
  
  return (
    <div className="h-full w-full flex items-center justify-start py-12">
      <div className="mx-auto grid w-[350px] gap-6">
        <div className="grid gap-2 text-center">
          <h1 className="text-3xl font-bold">{t("my_profile")}</h1>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4">
            {/* 
            <div className="grid gap-2">
              <Label htmlFor="firstName">{t("first_name")}</Label>
              <Input
                id="firstName"
                type="text"
                placeholder=""
                onChange={changeFirstName}
                ref={firstNameRef}
                value={firstName}
                required
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="lastName">{t("last_name")}</Label>
              <Input
                id="lastName"
                type="text"
                placeholder=""
                onChange={changeLastName}
                ref={lastNameRef}
                value={lastName}
                required
              />
            </div>
            */}
            <div className="grid gap-2">
              <Label htmlFor="displayName">{t("display_name")}</Label>
              <Input
                id="displayName"
                type="text"
                placeholder=""
                onChange={changeDisplayName}
                ref={displayNameRef}
                value={displayName}
                required
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="email">{t("email_address")}</Label>
              <Input
                id="email"
                type="email"
                placeholder="m@example.com"
                value={email}
                readOnly
                disabled
              />
            </div>
            {/*
            <div className="grid gap-2">
              <Label>{t("roles")}</Label>
              <UserRoleList roles={roles}/>                                                  

            </div>
             */}
            {errMsg ? <div className="error">{errMsg}</div> : ""}
            {success ? (
              <div className="success">{t("msg_saved")}</div>
            ) : (
              ""
            )}
            <Button type="submit" className="w-full">
              {t("save")}
            </Button>
          </div>
        </form>
        <button
          onClick={() => {
            navigate("/portal")
          }}
        >
          {t("cancel")}
        </button>
      </div>
    </div>
  );
}

export default MyUserProfile;
